/**
 * React Native-friendly mock for React Native Gesture Handler
 * Uses View wrappers and forwards refs to avoid ref warnings on native.
 */

import React, { forwardRef } from 'react';
import { View } from 'react-native';

// Generic wrapper that forwards ref
const GHView = forwardRef(({ children, ...props }, ref) => (
  <View ref={ref} {...props}>{children}</View>
));

export const GestureHandlerRootView = GHView;
export const PanGestureHandler = GHView;
export const TapGestureHandler = GHView;
export const LongPressGestureHandler = GHView;
export const PinchGestureHandler = GHView;
export const RotationGestureHandler = GHView;
export const FlingGestureHandler = GHView;

// Mock gesture handler state
export const State = {
  UNDETERMINED: 0,
  FAILED: 1,
  BEGAN: 2,
  CANCELLED: 3,
  ACTIVE: 4,
  END: 5,
};

// Mock directions
export const Directions = {
  RIGHT: 1,
  LEFT: 2,
  UP: 4,
  DOWN: 8,
};

// Mock gesture handler utilities
export const gestureHandlerRootHOC = (Component) => Component;

export default {
  GestureHandlerRootView,
  PanGestureHandler,
  TapGestureHandler,
  LongPressGestureHandler,
  PinchGestureHandler,
  RotationGestureHandler,
  FlingGestureHandler,
  State,
  Directions,
  gestureHandlerRootHOC,
};
